import React from "react";
import { useNavigate } from "react-router";
import Notifications from "./Notifications.js";

function NotificationsPopup(props) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        props.onHide();
      }}
      id="notification_container"
      style={{
        minHeight: 75,
        position: "absolute",
        filter: "drop-shadow(0 3px 8px rgba(0, 0, 0, .25)",
        zIndex: 2,
        left: -400,
        width: 400,
        top: 40,
      }}
    >
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div
          style={{
            width: 0,
            height: 0,
            borderLeft: "15px solid transparent",
            borderRight: "15px solid transparent",
            borderBottom: "15px solid white",
          }}
        />
      </div>
      <div style={{ border: "1px solid #ccc" }}>
        <div
          style={{
            maxHeight: "60vh",
            overflowX: "scroll",
            backgroundColor: "#ffffff",
            borderBottom: "#dddddd",
          }}
        >
          <div>
            <Notifications {...props} />
          </div>
        </div>
        <div
          onClick={() => {
            navigate("/shoe-reviews/notifications/");
          }}
          style={{
            textAlign: "center",
            backgroundColor: "#ffffff",
            padding: 15,
            fontWeight: "600",
            fontSize: 14,
            borderTop: "1px solid #cccccc",
          }}
        >
          See all Notifications
        </div>
      </div>
    </div>
  );
}

export default NotificationsPopup;
